import React, { FC } from 'react'
import styled from 'styled-components'
import { Box, theme } from '@mrshmllw/smores-react'

import { Logo } from './Logo'
import TrustPilotImg from 'assets/images/trustpilot-stars-4.5.svg'

export const SimpleHeader: FC = () => {
  return (
    <Wrapper>
      <ContentWrapper>
        <LogoWrapper flex justifyContent="space-between">
          <LogoBox>
            <Logo />
            <TrustPilotBox>
              <TrustPilot src={TrustPilotImg} />
              <TrustPilotText>
                Rated <B>Excellent</B> on Trustpilot
              </TrustPilotText>
            </TrustPilotBox>
          </LogoBox>
        </LogoWrapper>
      </ContentWrapper>
    </Wrapper>
  )
}

const LOGO_DESKTOP_WIDTH = 200

const Wrapper = styled.header`
  position: sticky;
  z-index: 5;
  display: flex;
  background-color: ${theme.colors.coconut};
`

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 12px 16px 8px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;

  @media (min-width: 768px) {
    padding: 16px 24px;
    flex-direction: row;
    justify-content: space-between;
    gap: 16px;
  }
`

const LogoWrapper = styled(Box)`
  width: 100%;

  @media (min-width: 768px) {
    width: auto;
  }
`

const LogoBox = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: '16px';
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: ${LOGO_DESKTOP_WIDTH}px;
  }
`

const TrustPilot = styled.img`
  width: 56px;

  @media (min-width: 768px) {
    width: 64px;
  }
`

const TrustPilotBox = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  row-gap: 4px;

  @media (min-width: 768px) {
    flex-wrap: nowrap;
  }
`

const TrustPilotText = styled.p`
  font-size: 10px;
  white-space: nowrap;
`

const B = styled.b`
  font-weight: ${theme.font.weight.medium};
`
